import React, { useState } from 'react';

import bg from '../assets/images/hero/pages.jpg'

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/scss/modal-video.scss'

import { Link } from 'react-router-dom';

export default function CtaTwo() {
    let [isOpen, setOpen] = useState(false);
  return (
    <>
        <section className="cta-video-section position-relative" style={{backgroundImage:`url(${bg})`, backgroundPosition:'center', backgroundAttachment:'fixed'}}>
            <div className="bg-overlay"></div>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="d-md-flex justify-content-center">
                            <Link to="#!" onClick={() => setOpen(true)} className="avatar avatar-md-md rounded-pill shadow bg-white d-flex justify-content-center align-items-center lightbox">
                                <i className="mdi mdi-play mdi-24px text-primary"></i>
                            </Link>
                        </div>

                        <div className="section-title text-center mt-4">
                            <h4 className="title text-white mb-0">Scalable & Growing Business for Startups.</h4>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <ModalVideo
        channel="youtube"
        youtube={{ mute: 0, autoplay: 0 }}
        isOpen={isOpen}
        videoId="yba7hPeTSjk"
        onClose={() => setOpen(false)} 
    />
    </>
  )
}
